<mat-card class="terms-view">
    <mat-card-header>
        <mat-card-title>TERMS OF SERVICE</mat-card-title>
        <mat-card-subtitle>Last updated November 17, 2023</mat-card-subtitle>
    </mat-card-header>

<mat-card-content>

    <h3>1. Acceptance of Terms</h3>
    <p>By accessing or using <strong>Price Matcher</strong> ("the Service"), you agree to these Terms of Service ("Terms") outlined here. If you do not agree with these Terms, you may not use the Service.</p>
    
    <h3>2. Service Description</h3>
    <p><strong>Price Matcher</strong> is a price comparison platform that allows users to compare product prices from various stores. The Service is provided free of charge during the beta phase and is subject to future updates or modifications.</p>
    
    <h3>3. Usage of Service</h3>
    <p>You are granted permission to use <strong>Price Matcher</strong> as long as your use is lawful and not abusive. Any misuse of the platform, including but not limited to automated data collection, excessive requests, or harmful activities, may result in restricted access or termination of your use of the Service.</p>
    
    <h3>4. Login Feature</h3>
    <p>Currently, no login is required to use the Service. However, a login feature may be added in the future to provide users with personalized experiences or additional functionalities.</p>
    
    <h3>5. Changes to the Service</h3>
    <p>We reserve the right to modify or discontinue any part of the Service without prior notice. While we strive to provide an uninterrupted Service, there may be instances of downtime, updates, or changes as we continue to develop the platform.</p>
    
    <h3>6. Liability</h3>
    <p>The information provided by <strong>Price Matcher</strong> is for general informational purposes only. While we aim to provide accurate price comparisons, we cannot guarantee the completeness or correctness of the information. <strong>[App Name]</strong> shall not be held liable for any decisions you make based on the information found on the platform.</p>
    
    <h3>7. No Warranties</h3>
    <p>The Service is provided on an "as-is" basis, without warranties of any kind, either express or implied. <strong>Price Matcher</strong> disclaims any and all warranties, including but not limited to the implied warranties of merchantability, fitness for a particular purpose, and non-infringement.</p>
    
    <h3>8. Governing Law</h3>
    <p>These Terms are governed by the laws of <strong>United States</strong>, without regard to conflict of law principles.</p>
</mat-card-content>
</mat-card>